var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_33_135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 34.375C26.8198 34.375 34.375 26.8198 34.375 17.5C34.375 8.18019 26.8198 0.625 17.5 0.625C8.18019 0.625 0.625 8.18019 0.625 17.5C0.625 26.8198 8.18019 34.375 17.5 34.375Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 31.25C25.0939 31.25 31.25 25.0939 31.25 17.5C31.25 9.90608 25.0939 3.75 17.5 3.75C9.90608 3.75 3.75 9.90608 3.75 17.5C3.75 25.0939 9.90608 31.25 17.5 31.25Z",
    fill: "white",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.625 39.375C35.4575 39.375 39.375 35.4575 39.375 30.625C39.375 25.7925 35.4575 21.875 30.625 21.875C25.7925 21.875 21.875 25.7925 21.875 30.625C21.875 35.4575 25.7925 39.375 30.625 39.375Z",
    fill: "white",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.875 30.625L28.75 33.125L35 28.125",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.5 11.25V17.5L22.5 22.5",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.5 5V8.125",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.5 30V26.875",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5 17.5H8.125",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30 17.5H26.875",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout3);
export default __webpack_public_path__ + "static/media/about3.5d9069e217867c475710046c7fbf0afc.svg";
export { ForwardRef as ReactComponent };